import React, { useEffect, useMemo, useState } from "react";
import CardLayout from "../common/CardLayout";
import ReactTable from "react-table-6";
import { Checkbox, Form } from "semantic-ui-react";
import { useIntl } from "react-intl";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";

const CARD_NURSE_NOTE_VIEW = "cardNurseNoteView";

const DEFAULT_PROPS = {
  closeable: true,
  toggleable: true,
  defaultBackground: true,
  hideHeaderIcon: false,
  nurseNote: [],
  onGetNurseNote: () => {},
  enableMargin: true,
};
const CardNurseNoteView = (propsParam) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value]) => value !== undefined)),
  };

  const [checkedIds, setCheckedIds] = useState<number[]>([]);

  useEffect(() => {
    props.onGetNurseNote({});
  }, []);

  const handleChecked = (checked: boolean, item: any) => {
    const ids: number[] = item.id_list || [item.id];

    if (checkedIds.some((id) => ids.includes(id))) {
      setCheckedIds(checkedIds.filter((id) => !ids.includes(id)));
    } else {
      setCheckedIds([...checkedIds, ...ids]);
    }
  };

  const handleCheckAll = (e: any, v: any) => {
    if (v.checked) {
      let allId = props.nurseNote.map((item: any) => {
        return item.id;
      });

      setCheckedIds(allId);
    } else {
      setCheckedIds([]);
    }
  };

  const columns = useMemo(() => {
    let result: any[] = [];
    result.push({
      Header: (
        <Checkbox
          checked={checkedIds.length === props.nurseNote.length && props.nurseNote.length > 0}
          onChange={handleCheckAll}
        />
      ),
      width: 80,
      Cell: (data: any) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Checkbox
              checked={checkedIds.includes(data.original.id)}
              onChange={(e, v) => {
                handleChecked(v.checked || false, data.original);
              }}
            />
          </div>
        );
      },
    });

    if (["IPD", "SS"].includes(props.encounterType)) {
      result.push({
        Header: "เวร",
        accessor: "working_shift",
        style: { whiteSpace: "unset" },
        width: 100,
      });
    }

    result.push(
      {
        Header: "วันและเวลาบันทึก",
        style: { whiteSpace: "unset" },
        width: 125,
        Cell: (data: any) => {
          return (
            <Form>
              <Form.Field>{data.original.formatted_date}</Form.Field>
            </Form>
          );
        },
      },
      {
        Header: "Focus",
        style: { whiteSpace: "unset" },
        width: 125,
        Cell: (data: any) => {
          return (
            <Form>
              <Form.Field>{data.original.focus}</Form.Field>
            </Form>
          );
        },
      },
      {
        Header: "การรักษาพยาบาล",
        accessor: "plan",
        style: { whiteSpace: "unset" },
        width: 150,
        Cell: (data: any) => {
          return (
            <Form>
              <Form.Field>
                <div
                  style={{ whiteSpace: "pre-line" }}
                  dangerouslySetInnerHTML={{ __html: data.original.plan }}
                />
              </Form.Field>
            </Form>
          );
        },
      },
      {
        Header: "ข้อวินิจฉัยการพยาบาลและข้อมูลสนับสนุน",
        accessor: "diagnosis",
        style: { whiteSpace: "unset" },
        width: 250,
        Cell: (data: any) => {
          return (
            <Form>
              <Form.Field>
                <div
                  style={{ whiteSpace: "pre-line" }}
                  dangerouslySetInnerHTML={{ __html: data.original.diagnosis }}
                />
              </Form.Field>
            </Form>
          );
        },
      },
      {
        Header: "กิจกรรมการพยาบาลและการประเมินผล",
        accessor: "goal",
        style: { whiteSpace: "unset" },
        width: 250,
      },
      {
        Header: "Nurse",
        accessor: "edit_user",
        style: { whiteSpace: "unset" },
        width: 130,
        Cell: (data: any) => {
          return (
            <Form>
              <Form.Field>
                {data.original.edit_user + "(" + data.original.nurse_code + ")"}
              </Form.Field>
            </Form>
          );
        },
      },
      {
        Header: "Division",
        accessor: "division_code",
        style: { whiteSpace: "unset" },
        width: 70,
      }
    );
    return result;
  }, [props.encounterType, checkedIds]);

  return (
    <CardLayout
      titleText={"Nurse's Note"}
      headerColor="blue"
      closeable={props.closeable}
      toggleable={props.toggleable}
      defaultBackground={props.defaultBackground}
      hideHeaderIcon={props.hideHeaderIcon}
      loading={props.nurseNoteLoading}
      enableMargin={props.enableMargin}
    >
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <ButtonLoadCheck
          // function
          setProp={props.setProp}
          onClick={() => {
            props.onEvent({
              message: "handleNurseNoteReport",
              params: {
                card: CARD_NURSE_NOTE_VIEW,
                nurseNoteList: props.nurseNote,
                selectedPatient: props.selectedPatient,
                encounterId: props.encounterId,
                checkedIds: checkedIds,
              },
            });
          }}
          // data
          paramKey={`${CARD_NURSE_NOTE_VIEW}_PRINT`}
          buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_NURSE_NOTE_VIEW}_PRINT`]}
          // config
          color={"blue"}
          icon="print"
          size="small"
        />
      </div>
      <ReactTable
        style={{ height: 470, backgroundColor: "#FFFFFF" }}
        showPagination={false}
        pageSize={props.nurseNote ? (props.nurseNote.length < 5 ? 5 : props.nurseNote.length) : 5}
        data={props.nurseNote}
        columns={columns}
      />
    </CardLayout>
  );
};

export default CardNurseNoteView;
